import React from 'react';
import { Card, CardContent, Badge, Button } from '@ncoder/ui';
import { Tag, Download, FileText } from 'lucide-react';

export interface ReleaseData {
  name: string;
  commit: string;
  date: string;
  description: string;
}

interface ReleaseCardProps {
  release: ReleaseData;
  onDownload?: (releaseName: string) => void;
  onViewNotes?: (releaseName: string) => void;
}

export const ReleaseCard: React.FC<ReleaseCardProps> = ({
  release,
  onDownload,
  onViewNotes,
}) => {
  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-3">
            <Tag className="h-5 w-5 text-muted-foreground" />
            <div>
              <div className="flex items-center gap-2">
                <span className="font-semibold">{release.name}</span>
                <Badge variant="outline" className="text-xs">
                  {release.commit}
                </Badge>
              </div>
              <p className="text-sm text-muted-foreground mt-1">{release.description}</p>
              <p className="text-xs text-muted-foreground mt-1">Released {release.date}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {onViewNotes && (
              <Button variant="outline" size="sm" onClick={() => onViewNotes(release.name)}>
                <FileText className="h-4 w-4 mr-1" />
                Notes
              </Button>
            )}
            {onDownload && (
              <Button variant="outline" size="sm" onClick={() => onDownload(release.name)}>
                <Download className="h-4 w-4 mr-1" />
                Download
              </Button>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
